import React, { useContext } from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { UiContext } from 'uiContext';
import { DEFAULT_ELEVATION } from 'assets/theme';
import IconCODD from 'icons/iconCODD';
import RoundedContainer from 'components/baseElements/roundedContainer';
import { getScoreThemeColor, makeTransition } from 'helpers/utils';

export type SpeedStatMobileProps = {
  score: number;
  isOpen: boolean;
};

export default function SpeedStatMobile({
  score,
  isOpen,
}: SpeedStatMobileProps) {
  const {
    spacings: {
      uiElems: {
        speedStat: { mobile },
      },
      sp,
    },
  } = useContext(UiContext);
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'stretch',
        height: mobile.height,
        opacity: isOpen ? 0 : 1,
        transition: makeTransition(['height', 'opacity']),
      }}
    >
      <RoundedContainer
        roundSide="left"
        radius={'6px'}
        sx={{
          bgcolor: getScoreThemeColor(score),
          gap: sp.s15,
          px: sp.s15,
        }}
      >
        <Typography variant="f14b" sx={{ color: 'custom.scoreDigit' }}>
          {score}
        </Typography>
      </RoundedContainer>

      <RoundedContainer
        roundSide="right"
        radius={'6px'}
        sx={{
          justifyContent: 'space-between',
          gap: sp.s20,
          py: sp.s10,
          px: '7px',
          background:
            // @ts-ignore
            theme.palette.customBackgrounds[
              `elevation${DEFAULT_ELEVATION + 1}`
            ],
        }}
      >
        <IconCODD sizeKey="9x12"></IconCODD>
      </RoundedContainer>
    </Box>
  );
}
